"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParagraphZoomImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing ParagraphZoom operations. */
var ParagraphZoomImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class ParagraphZoom class.
   * @param client Reference to the service client
   */
  function ParagraphZoomImpl(client) {
    (0, _classCallCheck2["default"])(this, ParagraphZoomImpl);
    this.client = client;
  }
  /**
   * Returns boolean value indicating whether a document has or does not have
   * paragraph zoom feature enabled for every paragraph in a document.
   * @param portalId
   * @param documentId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(ParagraphZoomImpl, [{
    key: "documentHasParagraphZoom",
    value: function documentHasParagraphZoom(portalId, documentId, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, documentHasParagraphZoomOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param familyHiveId
     * @param familyName
     * @param paragraphId
     * @param options The options parameters.
     */

  }, {
    key: "getParagraphZoom",
    value: function getParagraphZoom(portalId, familyHiveId, familyName, paragraphId, options) {
      var operationArguments = {
        portalId: portalId,
        familyHiveId: familyHiveId,
        familyName: familyName,
        paragraphId: paragraphId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getParagraphZoomOperationSpec);
    }
  }]);
  return ParagraphZoomImpl;
}(); // Operation Specifications


exports.ParagraphZoomImpl = ParagraphZoomImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var documentHasParagraphZoomOperationSpec = {
  path: "/api/Portals({portalId})/Documents/{documentId}/ParagraphZoom",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Boolean"
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getParagraphZoomOperationSpec = {
  path: "/api/Portals({portalId})/ParagraphZoom/Family/{familyHiveId}/{familyName}/Paragraph/{paragraphId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.ParagraphZoomQueryModel
    },
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.familyHiveId, Parameters.familyName1, Parameters.paragraphId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};